import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=65165528&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65165528')) {
      api.createRecord('65165528', component.options)
    } else {
      api.reload('65165528', component.options)
    }
    module.hot.accept("./FilterCard.vue?vue&type=template&id=65165528&", function () {
      api.rerender('65165528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/FilterCard.vue"
export default component.exports